// Company / settings API fetcher — Wave E.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type {
  CompanyOverviewResponse,
  CompanyProfile,
  CompanySettingItem,
  UpdateCompanyInput,
} from '../types/api';

export async function getCompanyOverview(): Promise<CompanyOverviewResponse> {
  const res = await apiClient.get<CompanyOverviewResponse>(
    endpoints.companySettings.overview,
  );
  return res.data;
}

export async function updateCompany(
  input: UpdateCompanyInput,
): Promise<CompanyProfile> {
  const res = await apiClient.patch<{ company: CompanyProfile }, UpdateCompanyInput>(
    endpoints.companySettings.update,
    input,
  );
  return res.data.company;
}

export async function listCompanySettings(): Promise<CompanySettingItem[]> {
  const res = await apiClient.get<{ settings: CompanySettingItem[] }>(
    endpoints.companySettings.list,
  );
  return res.data.settings;
}

export async function upsertCompanySetting(
  key: string,
  body: { value: string | null; type?: string; description?: string; is_secret?: boolean },
): Promise<CompanySettingItem> {
  const res = await apiClient.put<{ setting: CompanySettingItem }, typeof body>(
    endpoints.companySettings.upsert(key),
    body,
  );
  return res.data.setting;
}
